export const GET_RESPONSE_DETAILS_BY_ID = "GET_RESPONSE_DETAILS_BY_ID";
export const GET_REQUEST_DETAILS_BY_ID = "GET_REQUEST_DETAILS_BY_ID";
export const IS_LOADING = "IS_LOADING";
export const IS_SENT = "IS_SENT";
